"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _file = require("@ys/utils/lib/file");
var _default = exports.default = {
  name: 'ExportBlobToExcel',
  // 把通过后台接口返回的Blob格式数据导出为Excel文档
  props: {
    // 下载接口方法 method的配置必须带上config。如：export const getDataDownload = (params, config) => axios.get('/v1/data/download', params, config)
    method: {
      type: Function,
      required: true
    },
    // 请求的接口参数
    params: {
      type: Object,
      default: () => {
        return {};
      }
    },
    title: {
      type: String,
      default: '导出数据'
    },
    // 是否点击后立即执行导出方法；可通过this.$refs.exportExcel.export()进行手动触发
    immediate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    onClick() {
      this.$emit('click');
      if (this.immediate) {
        this.export();
      }
    },
    async export(payload = {}) {
      try {
        if (payload && typeof payload !== 'object') {
          console.warn('export方法的请求参数必须是对象');
        }
        this.loading = true;
        // 返回全量响应数据
        const {
          data,
          headers
        } = await this.method({
          ...this.params,
          ...payload
        }, {
          responseType: 'blob',
          originalData: true
        });
        const contentDisposition = headers['content-disposition'] || '';
        const arr = contentDisposition.match(/filename=(\S*)/);
        const filename = arr ? arr[1] : `${new Date().toLocaleDateString().replace(/\//g, '')}.xlsx`;
        await (0, _file.downloadFile)(data, filename);
        this.$emit('success', {
          filename
        });
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    }
  }
};